export default `
	guid
	updated_at
	code
	scanned_in_at
	scanned_in_through
	scanned_out_at
	scanned_out_through
	status
	
	building {
		guid
	}
`;
